module.exports = __webpack_public_path__ + "img/stage_enabled_3.fbf6f50b.png";